import React, { useState } from 'react';
import axios from 'axios';
import { useNavigate, useSearchParams } from 'react-router-dom';
import PasswordInput from '../Shared/PasswordInput';
import styles from './ResetPassword.module.css';

const ResetPassword = () => {
    const [newPassword, setNewPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [error, setError] = useState(null);
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();

    const uid = searchParams.get('uid');
    const token = searchParams.get('token');

    const passwordsEntered = newPassword.length > 0 && confirmPassword.length > 0;
    const passwordsMatch = newPassword === confirmPassword;

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError(null);

        if (!passwordsMatch) {
            setError("Passwords do not match.");
            return;
        }

        setLoading(true);

        try {
            await axios.post(`${process.env.REACT_APP_API_URL}/api/c/passwordresetconfirm/`, {
                uid,
                token,
                new_password: newPassword,
            });
            navigate('/login', { state: { passwordReset: true } });
        } catch (err) {
            if (!err.response) {
                setError("Unable to connect to server. Please try again later.");
            } else if (err.response.status === 400) {
                setError(err.response.data?.message || "Reset link is invalid or has expired.");
            } else {
                setError("Something went wrong. Please try again.");
            }
        } finally {
            setLoading(false);
        }
    };

    if (!uid || !token) {
        return (
            <div className={styles.container}>
                <h2 className={styles.title}>Invalid Link</h2>
                <p className={styles.subtitle}>This reset link is missing required information.</p>
                <button className={styles.submitButton} onClick={() => navigate('/forgotpassword')}>
                    Request a new link
                </button>
            </div>
        );
    }

    return (
        <div className={styles.container}>
            <h2 className={styles.title}>Reset Password</h2>
            <form className={styles.form} onSubmit={handleSubmit}>
                <label className={styles.label}>
                    New Password
                    <PasswordInput
                        value={newPassword}
                        onChange={(e) => setNewPassword(e.target.value)}
                        autoComplete="new-password"
                        required
                    />
                </label>
                <label className={styles.label}>
                    Confirm Password
                    <PasswordInput
                        value={confirmPassword}
                        onChange={(e) => setConfirmPassword(e.target.value)}
                        autoComplete="new-password"
                        required
                    />
                    {passwordsEntered && (
                        <span className={passwordsMatch ? styles.matchOk : styles.matchError}>
                            {passwordsMatch ? 'Passwords match' : 'Passwords do not match'}
                        </span>
                    )}
                </label>
                {error && <p className={styles.errorMessage}>{error}</p>}
                <button
                    className={styles.submitButton}
                    type="submit"
                    disabled={loading || !passwordsEntered || !passwordsMatch}
                >
                    {loading ? 'Resetting…' : 'Reset Password'}
                </button>
            </form>
        </div>
    );
};

export default ResetPassword;
